<ul>
  @for (item of navigationService.games(); track item.title;) {
  <li>
    <app-navigation-item [navigationItem]="item"></app-navigation-item>
  </li>
  }
</ul>
